var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "signup-audit-detail",
    },
    [
      _vm.record
        ? [
            _c("div", { staticClass: "signup-audit-info" }, [
              _c(
                "div",
                { staticClass: "signup-audit-info__user" },
                [
                  _c("yxt-avatar", {
                    attrs: {
                      size: "70px",
                      imgUrl: _vm.record.imgUrl,
                      username: _vm.record.fullname,
                    },
                  }),
                  _c("div", { staticClass: "ml16" }, [
                    _c("div", { staticClass: "flex" }, [
                      _c(
                        "div",
                        { staticClass: "fs18 fw500 c-cC26" },
                        [
                          _c("yxtbiz-user-name", {
                            attrs: { name: _vm.record.fullname },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "div",
                        { staticClass: "bc-cCF6F7FA pl8 pr8 c-cC59 ml12" },
                        [
                          _vm._v(
                            "\n              " +
                              _vm._s(
                                (_vm.statusMap[_vm.record.auditStatus] || {})
                                  .label || "--"
                              ) +
                              "\n              "
                          ),
                          _vm.record.auditStatus === 3 ||
                          _vm.record.auditStatus === 4
                            ? _c(
                                "yxt-tooltip",
                                {
                                  staticClass: "item",
                                  attrs: {
                                    effect: "dark",
                                    "max-width": 560,
                                    placement: "top",
                                  },
                                },
                                [
                                  _vm.record.auditStatus === 3
                                    ? _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.language().lbl_abandoner
                                                ) + "："
                                              ),
                                              _c("yxtbiz-user-name", {
                                                attrs: {
                                                  name: _vm.record
                                                    .optGiveUpUserfullname,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.language().lbl_give_up_time
                                              ) +
                                                "：" +
                                                _vm._s(_vm.record.actionTime)
                                            ),
                                          ]),
                                          _c("br"),
                                          _c("div", [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  display: "inline",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.language().lbl_reasons
                                                  ) + "："
                                                ),
                                              ]
                                            ),
                                            _c("pre", {
                                              staticStyle: {
                                                display: "inline",
                                              },
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.record.reason
                                                ),
                                              },
                                            }),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.record.auditStatus === 4
                                    ? _c(
                                        "div",
                                        {
                                          attrs: { slot: "content" },
                                          slot: "content",
                                        },
                                        [
                                          _c(
                                            "span",
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.language().lbl_operator
                                                ) + "："
                                              ),
                                              _c("yxtbiz-user-name", {
                                                attrs: {
                                                  name: _vm.record
                                                    .optGiveUpUserfullname,
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                          _c("br"),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.language()
                                                  .lbl_operation_time
                                              ) +
                                                "：" +
                                                _vm._s(_vm.record.actionTime)
                                            ),
                                          ]),
                                        ]
                                      )
                                    : _vm._e(),
                                  _c(
                                    "span",
                                    [
                                      _c("yxt-svg", {
                                        staticClass: "wh16 ml4 color-gray-6",
                                        attrs: {
                                          slot: "reference",
                                          "icon-class": "question-cirlce-o",
                                        },
                                        slot: "reference",
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "mt4 fs14 c-cC59 nowrap ellipsis" },
                      [
                        _c("yxtbiz-user-name", {
                          attrs: { name: _vm.record.username },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "flex mt8 fs14 c-cC26 align-items-center",
                      },
                      [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.language().lbl_position_name) + "："
                          ),
                        ]),
                        _c(
                          "yxt-tooltip",
                          {
                            staticClass: "nowrap ellipsis maxW450",
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              "open-filter": true,
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("yxtbiz-position-name", {
                                  attrs: {
                                    name: _vm.record.positionNameList || "--",
                                  },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("yxtbiz-position-name", {
                                  attrs: {
                                    name: _vm.record.positionNameList || "--",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c("yxt-divider", {
                          staticClass: "bc-cCBF ml12 mr12",
                          attrs: { direction: "vertical" },
                        }),
                        _c("span", [
                          _vm._v(_vm._s(_vm.language().lbl_department) + "："),
                        ]),
                        _c(
                          "yxt-tooltip",
                          {
                            staticClass: "ellipsis nowrap maxW450",
                            attrs: {
                              effect: "dark",
                              placement: "top",
                              "open-filter": true,
                            },
                          },
                          [
                            _c(
                              "span",
                              [
                                _c("yxtbiz-dept-name", {
                                  attrs: { name: _vm.record.deptName || "--" },
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { attrs: { slot: "content" }, slot: "content" },
                              [
                                _c("yxtbiz-dept-name", {
                                  attrs: { name: _vm.record.deptName || "--" },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "w100p h12 bc-cCF6F7FA" }),
              _c(
                "div",
                { staticClass: "signup-audit-info__project" },
                [
                  _c("div", { staticClass: "fs16 c-cC26 fw500" }, [
                    _c("div", { staticClass: "title-column" }),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.language().tit_project) +
                        "\n        "
                    ),
                  ]),
                  _vm._l(_vm.list, function (items, index) {
                    return _c(
                      "yxt-row",
                      {
                        key: index,
                        staticClass: "mt16",
                        attrs: { gutter: 30 },
                      },
                      _vm._l(items, function (item, i) {
                        return _c(
                          "yxt-col",
                          { key: i, staticClass: "flex", attrs: { span: 12 } },
                          [
                            _c("div", { staticClass: "fl color-gray-9" }, [
                              _vm._v(_vm._s(item.label) + "："),
                            ]),
                            _c("div", { staticClass: "flex-1" }, [
                              _vm._v(_vm._s(item.value || "--")),
                            ]),
                          ]
                        )
                      }),
                      1
                    )
                  }),
                ],
                2
              ),
              _vm.record.surveyProjectAnswerUrl
                ? _c("div", { staticClass: "signup-audit-opinion mb16" }, [
                    _c("div", { staticClass: "fs16 c-cC26 fw500" }, [
                      _c("div", { staticClass: "title-column" }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.language().tit_registration_form) +
                          "\n        "
                      ),
                    ]),
                    _c("div", { staticClass: "fs14 mt20" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative h40 pl40 bc-cCF5 rtl4 rtr4 rbl4 rbr4",
                        },
                        [
                          _c("img", {
                            staticClass: "absolute wh24 left12 top8",
                            attrs: {
                              src:
                                _vm.$staticBaseUrl +
                                "assets/862f0624/fba17c0a/investigate.svg",
                            },
                          }),
                          _c(
                            "span",
                            {
                              staticClass:
                                "c-cC26 ellipsis w148-max inline-block relative top9",
                            },
                            [_vm._v(_vm._s(_vm.record.surveyTemplateName))]
                          ),
                          _c(
                            "yxt-button",
                            {
                              staticClass: "pull-right relative top8 right12",
                              attrs: { size: "small", plain: "" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.toSurvey.apply(null, arguments)
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.language().btn_see_check))]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.record.attachments && _vm.record.attachments.length
                ? _c("div", { staticClass: "signup-audit-opinion mb16" }, [
                    _c("div", { staticClass: "fs16 c-cC26 fw500" }, [
                      _c("div", { staticClass: "title-column" }),
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.language().lbl_audit_files) +
                          "\n        "
                      ),
                    ]),
                    _c(
                      "div",
                      { staticClass: "fs14 mt20" },
                      _vm._l(_vm.record.attachments, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            class:
                              "inline-block " +
                              (index % 2 === 0 ? "" : "ml24") +
                              " border-box relative mb4 w50p-12 h40 pl40 bc-cCF5-hover rtl4 rtr4 rbl4 rbr4",
                            on: {
                              click: function ($event) {
                                return _vm.downloadFunc(item)
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticClass: "absolute wh20 left14 top10",
                              attrs: { src: _vm.getIconName(item.fileClass) },
                            }),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "c-cC26 ellipsis w148-max inline-block relative top9",
                                attrs: {
                                  title:
                                    item.name &&
                                    item.name.replace(/\.[^.]+$/, ""),
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    item.name &&
                                      item.name.replace(/\.[^.]+$/, "")
                                  )
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              {
                                staticClass:
                                  "c-cC26 inline-block relative top3",
                              },
                              [
                                _vm._v(
                                  "." +
                                    _vm._s(
                                      item.name && item.name.split(".").pop()
                                    )
                                ),
                              ]
                            ),
                            _c(
                              "span",
                              { staticClass: "c-cC8C fs12 ml8 relative top4" },
                              [_vm._v(_vm._s(_vm.getSize(item.size)))]
                            ),
                            _c("img", {
                              staticClass:
                                "x-close c-cC26-hover c-cC8C wh18 pointer absolute top11 right12",
                              attrs: {
                                src:
                                  _vm.$staticBaseUrl +
                                  "assets/259cb717/547f3640/%E8%B7%AF%E5%BE%84%202.svg",
                              },
                            }),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        : _c(
            "yxt-row",
            {
              staticClass: "signup-audit-detail__loading",
              attrs: { type: "flex", align: "center", justify: "middle" },
            },
            [!_vm.loading ? _c("yxt-empty") : _vm._e()],
            1
          ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }